import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-white grid grid-cols-1 items-center min-w-fit text-sm" }
const _hoisted_2 = { class: "flex justify-start items-center h-full p-3 border-b border-next-light-gray" }
const _hoisted_3 = { class: "flex justify-start items-center h-full p-3 border-t border-next-light-gray" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "top")
    ]),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "bottom")
    ])
  ]))
}